module.exports = __webpack_public_path__ + "static/media/1987_maleRate_femaleRate.88e5a0bd.png";